export default "./delete.svg"